// extracted by mini-css-extract-plugin
module.exports = {"wishlistModalTitle":"WishlistModalWishlist_wishlistModalTitle__1B8Ar"};